export const TRANSLATION_KEYS = {
    Heading: "settingPage.noticePage.deleteDialog.heading",
    SecondaryHeading: "settingPage.noticePage.deleteDialog.secondaryHeading",
    ConfirmText: "common.deleteText",
    DismissText: "common.dismissText"
};